/*
 * **********************************************
 * **********************************************
 * Registration and Login Pages logic
 * Page: /account/register,  /account/login
 * **********************************************
 * **********************************************
*/

let isCrmValidation = false;
let customerPhone = '';
let mfaTokenId = '';
let environments = {
  devqa: "proxy-qa",
  staging_and_production: "proxy"
};
let language = document.documentElement.getAttribute("lang");
if(language == "en-CA") language = "en";
if(language == "fr-CA") language = "fr";

const env = window.location.href.indexOf("dev1-newlook") !== -1 ? environments.devqa : environments.staging_and_production;

let codeRemainingAttempts = 3;

// Endpoints
const endpointGetMFATokenID = `/apps/${env}/mfa/customers/new`;
const endpointGetMFALogin = `/apps/${env}/mfa/customer/shopify`;
const endpointSendCode = `/apps/${env}/mfa/send-code`;
const endpointVerifyCode = `/apps/${env}/mfa/verify`;

// Common
function fade(element) {
    var op = 1;  // initial opacity
    var timer = setInterval(function () {
        if (op <= 0.1){
          clearInterval(timer);
          element.style.display = 'none';
          // Réinit opacity for next click (in case of several click)
          element.style.filter = 'alpha(opacity=1)';

        } else {
          element.style.opacity = op;
          element.style.filter = 'alpha(opacity=' + op * 100 + ')';
          op -= op * 0.1;
        }
    }, 50);
}
function showTechnicalIssuesMsg(step) {
  const errorMsg = document.querySelector('.mfa-technical-issues-' + step);
  // Show success message...
  errorMsg.style.opacity = "1";
  errorMsg.style.display = "block";
  // ... and hide it 5 seconds later
  setTimeout(() => {
    fade(errorMsg);
  }, 5000);
}

function showStep(steps, step) {
  steps.forEach(s => s.classList.add('hidden'));
  document.querySelector(`[data-register-step-${step}]`).classList.remove("hidden");
}

/* Called in METHOD SELECTION FOR VERIFICATION CODE FORM (after registration the customer is a new one) */
function toggleVerificationMethods (crm_validation, phone)
{
  /* ONLY the case of customer found in CRM */
  if (crm_validation) {
    if (!!phone) {
      /*
        If a phone number is available, do not allow method related to "Email"
        Currently each time a customer registers, an account is created with the email entered.
        If an account already exists, a match is made but the email already present is therefore overwritten with the new one.
        Which means that email is no longer reliable data.
        We therefore do not use email for the first validation.
        During the second validation, the email will be replaced by the new one and the client will have already been validated once.
      */
      document.querySelector('[data-method-email]')?.classList.add('hidden');
      document.querySelector("[data-account-email-method-wrapper]")?.classList.add('hidden');
    } else {
      /* If no phone number available, do not display methods related to "Phone Call" and "Text Message" */
      document.querySelector('[data-method-phone]')?.classList.add('hidden');
      document.querySelector('[data-method-text-message]')?.classList.add('hidden');
      document.querySelector("[data-account-phone-wrapper]")?.classList.add('hidden');
    }
  }
  // For NEW customer.... just to be sure to not display methods related to "Phone Call" and "Text Message" in case of bug for any reason (phone number is not returned by endpoint)
  else if(phone == ''){
    document.querySelector('[data-method-phone]')?.classList.add('hidden');
    document.querySelector('[data-method-text-message]')?.classList.add('hidden');
  }
}

const mfaRequest = async (endpoint, data) => {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // Add any additional headers if needed
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();
  return result;
}


/*
 * ==============================================
 *  LOGIN FORM
 * ==============================================
 */

const initLoginForm = () => {
  const loginForm = document.getElementById("customer_login");
  const steps = document.querySelectorAll(".register-step");
  const stepForms = document.querySelectorAll('.step-form');
  /*
    stepForms contains references to the following forms:
      - LOG IN FORM (after registration if the customer already exists)
      - METHOD SELECTION FOR VERIFICATION CODE FORM (after registration the customer is a new one)
      - VERIFICATION CODE CONFIRMATION FORM
  */
  
  /* Used in all forms steps (exist, method, code) except registration form */
  function handleSubmit(event) {
    event.preventDefault();
    const currentStepData = event.target.dataset.registerStep;

    switch (currentStepData) {

      /* METHOD SELECTION FOR VERIFICATION CODE FORM (after registration the customer is a new one) */
      case 'method':
        showStep(steps,'code');
        break;

      /* VERIFICATION CODE CONFIRMATION FORM */
      case 'code':
        break;

      /* Nothing */
      default:
        break;
    }
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  /* Called in Login Form ONLY */
  const onLoginFormSubmit = async (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    let formData = new FormData(e.target);
    // get email from login form
    const userEmail = Object.fromEntries(formData)["customer[email]"];
    try {
    /* CALL request to get MFA Token ID */
    const responceMFALogin = await mfaRequest(endpointGetMFALogin, {email: userEmail})
      /*
    Exemple of result when found in CRM and validation passed:

      "id": "9ad9793a-93c9-4c40-9ad4-dca6c9b63c35",
      "email": "******************ant@newlookvision.ca",
      "phone": "*** *** **64",
      "matches": [
          "**********ant@gmail.com",
          "************t++@hotmail.com",
          "*************+++@hotmail.com",
          "*************164@newlookvision.ca"
      ],
      "crm_validation": true,
      "validation_needed": true,

    Exemple of result when customer NOT found in CRM and validation was NOT passed:

      "id": "9adb0cd7-ef9c-4b05-a2d2-945c52072ee7",
      "email": "***************ant@newlookvision.ca",
      "phone": "*** *** **64",
      "matches": [],
      "crm_validation": false,
      "validation_needed": false,


    Exemple of result when customer does not exist in Shopify

      "status": false, 
      "message": "Customer does not exist"

    */
      const { id, crm_validation, email, phone, validation_needed } = responceMFALogin;

      if(responceMFALogin.message && responceMFALogin.message == "Customer does not exist"){
        showTechnicalIssuesMsg('customer-not-exist');
      } else {
        isCrmValidation = crm_validation;
        /* Save the MFA Token Id  */
        mfaTokenId = id;
  
        // continue submitting if "validation_needed" === false
        if (!validation_needed) {
          e.target.submit();
        } else {
          const emailWrapperMethod = document.querySelector("[data-account-email-method]");
          const phoneWrapper = document.querySelector("[data-account-phone]");
  
          emailWrapperMethod.innerHTML = email;
          phoneWrapper.innerHTML = phone;
  
          showStep(steps, 'method');
          toggleVerificationMethods(isCrmValidation, phone);
        }
      }

      
    } catch (error) {
      console.error('Error in getting MFA token id:', error);
      showTechnicalIssuesMsg('token-id');
    }
  }

  stepForms.forEach(f => f.addEventListener('submit', handleSubmit))
  loginForm.addEventListener('submit', onLoginFormSubmit);
}

/*
 * ==============================================
 *  REGISTRATION FORM
 * ==============================================
 */
const initRegistrationForm = () => {
  const stepForms = document.querySelectorAll('.step-form');
  /*
    stepForms contains references to the following forms:
      - LOG IN FORM (after registration if the customer already exists)
      - METHOD SELECTION FOR VERIFICATION CODE FORM (after registration the customer is a new one)
      - VERIFICATION CODE CONFIRMATION FORM
  */

  const steps = document.querySelectorAll(".register-step");
  /*
    steps contains references to the following forms:
      - REGISTRATION FORM
      - LOG IN FORM (after registration if the customer already exists)
      - METHOD SELECTION FOR VERIFICATION CODE FORM (after registration the customer is a new one)
      - VERIFICATION CODE CONFIRMATION FORM
  */

  const datePicker = document.querySelector("[data-date-picker]"); /* For birth date */
  const registrationForm = document.querySelector("#RegisterForm");

  // const genderField = document.querySelector("[name='customer[note][gender]']");
  const emailField = document.querySelector("[name='customer[email]']");
  const confirmEmailField = document.querySelector("[name='confirm-email']");
  const passwordField = document.querySelector("[name='customer[password]']");
  const confirmPasswordField = document.querySelector("[name='confirm-password']");
  const phoneField = document.querySelector("[name='customer[note][phone-number]']");
  const postalcodeField = document.querySelector("[name='customer[note][postal-code]']");
  const firstNameField = document.querySelector("[name='customer[first_name]']");
  const lastNameField = document.querySelector("[name='customer[last_name]']");
  const dateOfBirthField = document.querySelector("[name='customer[note][date-of-birth]']");
  const termsAndPrivacyPolicy = document.querySelector("[name='customer[note][policies-acknowledgment-date]']");
  /* Honey Pot (against robots) */
  const fakeNameField = document.querySelector("[name='Name']");
  const fakeAcceptFormCheckbox = document.querySelector("[name='AcceptForm']");

  if(!datePicker || !registrationForm) return;

  const format = "yyyy-mm-dd";

  const startViewParam = {
    decades: 3,
    years: 2,
    monthes: 1,
    days: 0
  }

  const subtractYears = (date, years) => {
    date.setFullYear(date.getFullYear() - years);
  
    return date;
  }
  
  const currentDate = new Date();
  const maxDate = subtractYears(currentDate, 14);

  new Datepicker(datePicker, {
    format,
    language,
    startView: startViewParam.years,
    autohide: true,
    minDate: new Date("01-01-1900"),
    maxDate: maxDate
  }); 
  
  const { MaskInput } = Maska

  new MaskInput("[data-maska]")

  const selects = document.querySelectorAll("[data-select]"); /* Only one select... for language*/

  if(!window.niceSelectInstances) window.niceSelectInstances = [];

  selects.forEach(select => {
    const instance = NiceSelect.bind(select);
    window.niceSelectInstances.push(instance);
  });

  /* Used in all forms steps (exist, method, code) except registration form */
  function handleSubmit(event) {
    event.preventDefault();
    const currentStepData = event.target.dataset.registerStep;

    switch (currentStepData) {
      /* LOG IN FORM (after registration if the customer already exists) */
      case 'exist':
        showStep(steps, 'method');
        toggleVerificationMethods(isCrmValidation, customerPhone);
        break;

      /* METHOD SELECTION FOR VERIFICATION CODE FORM (after registration the customer is a new one) */
      case 'method':
        showStep(steps,'code');
        break;

      /* VERIFICATION CODE CONFIRMATION FORM */
      case 'code':
        break;

      /* Nothing */
      default:
        break;
    }
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  stepForms.forEach(f => f.addEventListener('submit', handleSubmit))

  /* Called in Registration Form ONLY */
  const onRegisterFormSubmit = async (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    let basicNesting = 1;
    let nesting = 2;

    // const isValidGender = notEmptyField(genderField);
    const isValidEmailAddress = notEmptyField(emailField, basicNesting, errorKeys.enterValidEmail) && isValidEmail(emailField);
    const isValidConfirmEmail = notEmptyField(confirmEmailField, basicNesting, errorKeys.enterValidEmail) && isValidEmail(confirmEmailField);
    const isValidPassword = notEmptyField(passwordField, nesting, errorKeys.enterValidPassword);
    const isValidConfirmPassword = notEmptyField(confirmPasswordField, nesting, errorKeys.enterValidPassword);

    const isEmailsSame = isValidEmailAddress && isValidConfirmEmail && doValuesMatch(emailField, confirmEmailField);
    const isPasswordsSame = isValidPassword && isValidConfirmPassword && doValuesMatch(passwordField, confirmPasswordField, nesting) && checkFieldLength({ field: passwordField, nesting });
    const isPhoneValid = notEmptyField(phoneField, basicNesting, errorKeys.enterValidPhone) && await isValidPhone(phoneField);
    const isPostalCodeValid = notEmptyField(postalcodeField, basicNesting, errorKeys.enterValidPostalCode) && isValidPostalCode(postalcodeField);
    const isFirstNameEmpty = notEmptyField(firstNameField, basicNesting, errorKeys.enterFirstName);
    const isLastNameEmpty = notEmptyField(lastNameField, basicNesting, errorKeys.enterLastName);
    const isDateOfBirthEmpty = notEmptyField(dateOfBirthField, nesting, errorKeys.enterValidDate);
    const isTermsAndPrivacyPolicyChecked = checkedBox(termsAndPrivacyPolicy, nesting, errorKeys.pleaseAcknowledgeTermsAndPrivacyPolicy);
    /* Check Honey Pot (against robots) */
    const isFakeNameEmpty = fakeNameField.value.trim() == "";
    const isFakeAcceptFormChecked = fakeAcceptFormCheckbox.checked;

    if(
      isEmailsSame
      && isPasswordsSame
      && isPhoneValid
      && isPostalCodeValid
      && isFirstNameEmpty
      && isLastNameEmpty
      && isDateOfBirthEmpty
      && isTermsAndPrivacyPolicyChecked
      && isFakeNameEmpty
      && !isFakeAcceptFormChecked
    ) {
      try {
        const emailWrapperExist = document.querySelector("[data-account-email-exist]");
        const emailWrapperMethod = document.querySelector("[data-account-email-method]");
        const phoneWrapper = document.querySelector("[data-account-phone]");
        /*
          Both wrappers refer to email and phone avaibale in:
            - LOG IN FORM (after registration if the customer already exists)
            - METHOD SELECTION FOR VERIFICATION CODE FORM (after registration the customer is a new one)
        */

        // Body request for endpointGetMFATokenID
        // Regarding phone number, we remove all non-numeric characters, and about postal code we remove space
        const cleanedPhone = phoneField.value.replace(/\D/g, "");
        const cleanedPostalCode = postalcodeField.value.replace(/ /g, "");
        const requestDataGetMFATokenID = {
          first_name: firstNameField.value,
          last_name: lastNameField.value,
          dob: dateOfBirthField.value, /* yyyy-mm-dd even if dd-mm-yyyy (see Postman) seems to be also accepted */
          postal_code: cleanedPostalCode,
          email: emailField.value,
          phone: cleanedPhone
        };
        /* CALL request to get MFA Token ID */
        const result = await mfaRequest(endpointGetMFATokenID, requestDataGetMFATokenID);
        /*
          Exemple of result when found in CRM:

            "id": "9ad9793a-93c9-4c40-9ad4-dca6c9b63c35",
            "email": "******************ant@newlookvision.ca",
            "phone": "*** *** **64",
            "matches": [
                "**********ant@gmail.com",
                "************t++@hotmail.com",
                "*************+++@hotmail.com",
                "*************164@newlookvision.ca"
            ],
            "crm_validation": true

          Exemple of result when customer NOT found in CRM:

            "id": "9adb0cd7-ef9c-4b05-a2d2-945c52072ee7",
            "email": "***************ant@newlookvision.ca",
            "phone": "*** *** **64",
            "matches": [],
            "crm_validation": false
        */
        //console.log(result);
        const { id, crm_validation, matches, email, phone } = result;

        /* Save the MFA Token Id  */
        mfaTokenId = id;

        if(result.message &&  result.message == "An account already exists for this email address"){
          showTechnicalIssuesMsg('customer-already-exist');
        }else if (matches.length > 0)
        {
        /* Customer found in CRM */
        /* NOTE: "matches" contains emails FROM SHOPIFY accounts and NOT from CRM !!!!!!  */
          //console.log('Customer matched');
          /* LOG IN FORM (after registration if the customer already exists) */
          showStep(steps, 'exist'); /* Account exists in SHOPIFY */
        }
        /* Customer NOT found in CRM */
        else
        {
          //console.log('New customer');
          /* METHOD SELECTION FOR VERIFICATION CODE FORM (after registration the customer is a new one) */
          showStep(steps,'method')
        }

        isCrmValidation = crm_validation;
        if( phone ){
          customerPhone = phone;
        }

        /* Show the relevant methods that can be used */
        toggleVerificationMethods(isCrmValidation, customerPhone);

        /* Update summary information in forms (not with showStep above because we have 2 flows: directly to Method, or to Exist followed by Method. We manage all displays only once here */
        if (email) {
          /* In case of existing customer with matches, only display emails from "matches" element (not the one from "email" element) */
          /* Case Exist */
          if (matches.length > 0)
          {
            const emails = Array.from(matches).join('<br/>');
            emailWrapperExist.innerHTML = emails;
          }
          /* Case Method */
          emailWrapperMethod.innerHTML = email;
        }
        if (customerPhone != '') {
          phoneWrapper.innerHTML = customerPhone;
        }
        else{
          const phoneBlock = document.querySelectorAll('.mfa-info-phone');
          phoneBlock.forEach(w => w.classList.add('hidden'));
        }

      } catch (error) {
        console.error('Error in getting MFA token id:', error);
        showTechnicalIssuesMsg('token-id');
      }
    }
  }

  /* Masks */
  const phoneMaskOptions = {
    mask: '(#00) #00-0000',
    definitions: {
      '#': /[2-9]/i
    }
  };
  const postalCodeOptions = {
    mask: '#0$ 0$0',
    definitions: {
      '#': /[ABCEGHJKLMNPRSTVXY]/i,
      "$": /[ABCEGHJKLMNPRSTVXYWZ]/i
    },
    postProcess: (value) => value.slice(0, 7)
  };
  IMask(phoneField, phoneMaskOptions);
  IMask(postalcodeField, postalCodeOptions);

  const guestScanKey = 'guest_scan'; // Key for session storage

  // Retrieve and parse guest_scan from session storage
  let guestScan = JSON.parse(localStorage.getItem(guestScanKey));

  // Show checkbox if ID and has_scan are exist
  if (guestScan?.id && guestScan?.has_scan) {
    const imputWrapper = registrationForm.querySelector("[data-vto-id-wrapper]");
    if (imputWrapper) {
      imputWrapper.querySelector("input").value = guestScan.id;
      imputWrapper.classList.remove("hidden");
    }
  }

  registrationForm.addEventListener("submit", onRegisterFormSubmit);
}
/* (END)  REGISTRATION FORM */

/*
 * ==============================================
 *  METHOD SELECTION FOR VERIFICATION CODE FORM
 * ==============================================
 */
const SendCode = async function(selectedMethod) {
    /* Body request for endpointSendCode */
    const requestDataSendCode = {
      id: mfaTokenId,
      channel: selectedMethod,
      language: language
    };
//console.log(requestDataSendCode);
    /* CALL request to send code to customer */
    const responseSendCode = await fetch(endpointSendCode, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Add any additional headers if needed
      },
      body: JSON.stringify(requestDataSendCode),
    });

    const result = await responseSendCode.json(); /* 200 or 500 */
}
const initSendVerificationCodeForm = () => {
  const selectMethodAndSendCodeForm = document.querySelector('[data-register-step-method]');
  const methods = selectMethodAndSendCodeForm.querySelectorAll('input'); /* The 3 MFA methods */

  if(!selectMethodAndSendCodeForm) return;

  /* Called in Method Selection for Verification Code Form ONLY */
  const onMethodSelectionFormSubmit = async (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    const selectedOption = document.querySelector("[name='proceed-method-type']:checked");
    if(selectedOption !== null)
    {
      try {
        SendCode(selectedOption.value); /*Email is sent by SendGrid from twillio*/

      } catch (error) { /* Error 500 for example */
        console.error('Error in sending verification code:', error);
        showTechnicalIssuesMsg('send-code');
      }
    }
  }

  function handleSubmitButton() {
    if(this.checked){
      this.parentNode.querySelector('button').disabled = false;
    }
  }

  selectMethodAndSendCodeForm.addEventListener("submit", onMethodSelectionFormSubmit);
  methods.forEach(f => f.addEventListener('change', handleSubmitButton))
}
/* (END)  METHOD SELECTION FOR VERIFICATION CODE FORM */

/*
 * ==============================================
 *   VERIFICATION CODE CONFIRMATION FORM
 * ==============================================
 */
const initVerificationCodeForm = (isLoginForm) => {
  const steps = document.querySelectorAll(".register-step");
  const submitForm = document.querySelector(isLoginForm ? "#customer_login" : "#RegisterForm");
  const verificationCodeForm = document.querySelector('[data-register-step-code]');
  const inputs = verificationCodeForm.querySelectorAll('input'); /* The 6 boxes for the 6-digit code */
  const verifyButton = verificationCodeForm.querySelector('button'); /* VERIFY button */

  /* https://developer.mozilla.org/docs/Web/API/KeyboardEvent/key */
  const KEYBOARDS = {
    backspace: 'Backspace',
    arrowLeft: 'ArrowLeft',
    arrowRight: 'ArrowRight',
  };

  /*
   * Resend code
   */
  const codeResendLink = document.querySelector("[data-resend-code]");

  function showResentCodeMsg() {
    const successMsg = document.querySelector('.mfa-resend-code-text');
    // Show success message...
    successMsg.style.opacity = "1";
    successMsg.style.display = "block";
    // ... and hide it 5 seconds later
    setTimeout(() => {
      fade(successMsg);
    }, 5000);
  }

  codeResendLink.addEventListener('click', () => {
    const selectedOption = document.querySelector("[name='proceed-method-type']:checked");
    if(selectedOption !== null)
    {
      try {
        SendCode(selectedOption.value);
        showResentCodeMsg();

      } catch (error) { /* Error 500 for example */
        console.error('Error in resending verification code:', error);
      }
    }
  });

  /*
   * Go back link (to select new method)
   */
  const changeMethodLink = document.querySelector("[data-change-method]");

  changeMethodLink.addEventListener('click', () => {
    steps.forEach(s => s.classList.add('hidden'));
    document.querySelector(`[data-register-step-method]`).classList.remove("hidden");
  });

  /*
   * Verification code form functions
   */
  function handleSubmitButton() {
    // Enable or disable the button based on whether all fields are filled
    verifyButton.disabled = !Array.from(inputs).every((input) => input.value.trim() !== '');
    if(!verifyButton.disabled){
      verifyButton.focus();
    }
  }
  function handleInput(e) {
    const input = e.target;
    const nextInput = input.nextElementSibling;

    if (nextInput && input.value) {
      nextInput.focus();
      if (nextInput.value) {
        nextInput.select();
      }
    }

    handleSubmitButton();
  }
  function getEnteredCode(){
    let enteredCode = Array.from(inputs).map(input => input.value).join('');
    return enteredCode;
  }
  /* Called in Verification Code Form ONLY */
  const onFormSubmit = async (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    const enteredCode = getEnteredCode();
    //console.log('Code entered:', enteredCode);
    if(enteredCode !== '' && enteredCode.length==6)
    {
      try {
        /* Body request for endpointVerifyCode */
        const requestDataVerifyCode = {
          id: mfaTokenId,
          code: enteredCode
        };

        /* CALL request to check code validity */
        const responseVerifyCode = await fetch(endpointVerifyCode, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // Add any additional headers if needed
          },
          body: JSON.stringify(requestDataVerifyCode),
        });

        const result = await responseVerifyCode.json(); /* 200 or 500 */
        /*
          Exemple of result when OK:

            No status/message (Note: I (Emmanuel) have requested Valerii to have an answer consistent with the one of wrong code)

          Exemple of result when error (Wrong verification code or 5-minute time limit exceeded):

            "status": false,
            "message": "Verification code is not valid"

        */
        const { status } = result;
        let verifStatus = false;
        if(status === undefined || typeof status == "undefined")
            { verifStatus = true; }
        else{ verifStatus = status; }

        const codeFormWrapper = document.querySelector(".mfa-code-form");
        const remainingNumberWrapper = document.querySelector("[data-remaining-attempts-value]");
        const remainingUnitWrapper = document.querySelector("[data-remaining-attempts-unit]");
        const remainingUnitsWrapper = document.querySelector("[data-remaining-attempts-units]");

        /* Verification code is not valid */
        if (!verifStatus) {
          remainingNumberWrapper.innerHTML = --codeRemainingAttempts;
          /* Still remaining attempts */
          if(codeRemainingAttempts>0){
            /* manage single/plural units */
            if(codeRemainingAttempts>1){
              remainingUnitWrapper.classList.add('hidden');
              remainingUnitsWrapper.classList.remove('hidden');
            } else {
              remainingUnitWrapper.classList.remove('hidden');
              remainingUnitsWrapper.classList.add('hidden');
            }
            /* Display error */
            codeFormWrapper.classList.add('error');
            /* Remove entered code */
            inputs.forEach(i => i.value = '');
            /* Disable verify button */
            verifyButton.disabled = true;

          /* No more attempt... show cancellation page */
          } else {
            steps.forEach(s => s.classList.add('hidden'));
            document.querySelector(`[data-register-step-mfa-failed]`).classList.remove("hidden");
          }

        /* Verification code valid */
        } else {
          codeFormWrapper.classList.remove('error');
          if (isLoginForm) {
            /* Save status in registration form (customer note) before... */
            document.querySelector("#customer_login-mfa").value = "yes";
            document.querySelector("#customer_login-mfa-first").value = "yes";
          } else {
            /* Save status in registration form (customer note) before... */
            document.querySelector("#RegisterForm-mfa").value = "yes";
            document.querySelector("#RegisterForm-mfa-id").value = mfaTokenId;
          }
          /* ...submitting the form */
          submitForm.submit();
        }

      } catch (error) { /* Error 500 for example */
        console.error('Error in verifying code:', error);
        showTechnicalIssuesMsg('verif-code');
      }
    }
  }
  verificationCodeForm.addEventListener('input', handleInput);
  verificationCodeForm.addEventListener("submit", onFormSubmit);

  /*
   * Digit boxes functions
   */
  function handlePaste(e) {
    e.preventDefault();
    const paste = e.clipboardData.getData('text');
    // Insert the code
    inputs.forEach((input, i) => {
      input.value = paste[i] || '';
      if (input.value != '') {
        input.classList.add('filled');
      } else {
        input.classList.remove('filled');
      }
    });

    // Enable button
    handleSubmitButton();
  }
  function handleBackspace(e) {
    const input = e.target;
    if (input.value) {
      input.value = '';
      handleSubmitButton();
      return;
    }

    const previousInput = input.previousElementSibling;
    if (previousInput) {
      previousInput.focus();
    }
  }
  function handleArrow(e, direction) {
    const target = direction === 'left' ? e.target.previousElementSibling : e.target.nextElementSibling;
    if (target) {
      target.focus();
    }
  }
  function handleArrowLeft(e) {
    handleArrow(e, 'left');
  }
  function handleArrowRight(e) {
    handleArrow(e, 'right');
  }
  function handleFocus(e) {
    setTimeout(() => {
      e.target.select();
    }, 0);
  }
  function handleBlur(e) {
    const input = e.target;
    if (input.value) {
      input.classList.add('filled');
    } else {
      input.classList.remove('filled');
    }
  }
  inputs[0].addEventListener('paste', handlePaste); /* Allow pasting code on first box */
  inputs.forEach((input) => {
    input.addEventListener('focus', handleFocus);
    input.addEventListener('blur', handleBlur);

    input.addEventListener('keydown', (e) => {
      switch (e.key) {
        case KEYBOARDS.backspace:
          handleBackspace(e);
          break;
        case KEYBOARDS.arrowLeft:
          handleArrowLeft(e);
          break;
        case KEYBOARDS.arrowRight:
          handleArrowRight(e);
          break;
        default:
      }
    });
  });
};
/* (END)  VERIFICATION CODE CONFIRMATION FORM */

/*
 * ==============================================
 *   ACCOUNT CREATION CANCELLATION / NEED ASSISTANCE
 * ==============================================
 */
const initAssistanceForms = () => {
  const liveChatButtons = document.querySelectorAll(".live-chat");
  liveChatButtons.forEach(f => f.addEventListener('click', () => {
    GorgiasChat.open();
  }));
};
/* (END)  ACCOUNT CREATION CANCELLATION / NEED ASSISTANCE */


document.addEventListener("DOMContentLoaded", async () => {
  if (window.location.pathname.includes('login')) {
    initLoginForm();
    initVerificationCodeForm(true);
  } else {
    initRegistrationForm();
    initVerificationCodeForm(false);
  }
  initSendVerificationCodeForm();
  initAssistanceForms();
});